import { internalLogger } from '../../../interface/v1/clientOsLogger';
import {
  EventServicePlugin,
  EventServicePluginError,
  JWebWindow,
  Publisher,
  Subscriber
} from '../types';
import { jWebStates } from '../Initializer';

/**
 * Facade for EventService operations
 */
export class EventServiceFacade {
  /**
   * Get the EventService plugin
   */
  private static async getEventServicePlugin(): Promise<
    EventServicePlugin | undefined
  > {
    await this.isEventServiceReady();

    const windowEventService: EventServicePlugin = (window as JWebWindow)?.JWeb
      ?.Plugins?.EventService;
    if (!windowEventService) {
      internalLogger?.error(
        'Unable to obtain EventService (missing some JWeb plugin)'
      );
    }
    return windowEventService;
  }

  private static async isEventServiceReady(): Promise<boolean> {
    // Is Jweb ready?
    await jWebStates.JWebLibrary;

    // Is the plugins registered?
    await jWebStates.defaultPluginsRegistered;

    // Was valueStore installed?
    await jWebStates.plugins.EventService;
    return true;
  }

  /**
   * Create a Publisher instance
   */
  public static async createPublisher(publisherId: string): Promise<Publisher> {
    const eventServicePlugin = await this.getEventServicePlugin();
    const publisher = (await eventServicePlugin.createPublisher(
      publisherId
    )) as Publisher;
    return publisher;
  }

  /**
   * Get a new Subscriber instance
   */
  public static async getSubscribe(): Promise<Subscriber> {
    const eventServicePlugin = await this.getEventServicePlugin();
    const subscriber =
      (await eventServicePlugin.createSubscriber()) as Subscriber;
    return subscriber;
  }

  /**
   * Create a Subscriber
   */
  public static async createSubscriber(): Promise<
    Subscriber | EventServicePluginError
  > {
    const eventServicePlugin = await this.getEventServicePlugin();
    return eventServicePlugin.createSubscriber();
  }
}
